var $befc8e5be0b9f8d5$exports = {};
$befc8e5be0b9f8d5$exports = {
    "alert": `Warnhinweis`,
    "dismiss": `Schlie\xdfen`
};


export {$befc8e5be0b9f8d5$exports as default};
//# sourceMappingURL=de-DE.mjs.map
